import { type Coupon } from '@/hooks/api/mutations/useValidateCouponMutation';

export function getPriceWithCouponDiscount(
  price: number,
  coupon?: Coupon | null,
  isAnnual?: boolean
) {
  let finalPrice = price;

  if (isAnnual) {
    finalPrice /= 12;
  }
  if (coupon && coupon.valid) {
    if (coupon.percent_off) {
      finalPrice *= 1 - coupon.percent_off / 100;
    }

    // Stripe sends the amount_off in cents
    if (coupon.amount_off) {
      finalPrice -= coupon.amount_off / 100;
    }
  }
  return Math.round(finalPrice);
}
